module.exports = __webpack_public_path__ + "10b77d08b363d5b8f47ed7f7d6dde399.svg";